import { usePageContextState } from "../../../context/PageContext";
import { func } from "../../../utils";
import Text from "../Text";

const Announce = ({ bgColor = "#1F2D3D", highlightColor = "#00BCF1" }) => {
  const { pageMode } = usePageContextState();
  return (
    <div
      id="announce"
      style={{
        display: "flex",
        width: "100%",
        backgroundColor: bgColor,
        padding: "7px 0px",
        justifyContent: "center",
        color: "#00BCF1",
      }}
    >
      <img
        src={func.getStaticImg("/illustration/voucher.svg")}
        alt="voucher-icon"
        style={{ marginRight: 8 }}
      />
      <Text color="white" weight="bold" size="micro" removeGap>
        Ssst! Ada promo paket spesial loh buat kamu!{" "}
        <span
          style={{
            color: highlightColor,
            fontSize: 13,
            textDecoration: "underline",
            cursor: "pointer",
            marginLeft: 2,
          }}
          onClick={() =>
            pageMode === "home-details"
              ? func.scrollTo("footer-landing", null, 64)
              : func.scrollTo("footer-landing")
          }
        >
          Klik Disini
        </span>
      </Text>
    </div>
  );
};

export default Announce;
